<template>
  <v-dialog
    persistent
    :value="dialog"
    @input="$emit('disagree')"
    max-width="590"
  >
    <v-card>
      <v-toolbar class="secondary-color" flat>
        <v-toolbar-title class="white--text">
          Editar reserva {{ vehicleRequestId }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pa-6">
        <div>
          <span class="subheading grey--text text--darken-2">
            Data e hora do novo check-in
          </span>
          <datetime
            style="border: 1px solid grey"
            input-id="inputDate"
            type="datetime"
            value-zone="America/Sao_Paulo"
            zone="America/Sao_Paulo"
            :minute-step="10"
            v-model="begin_date"
          ></datetime>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="green darken-1" text @click="$emit('disagree')">
          Cancelar
        </v-btn>

        <v-btn color="green darken-1" text @click="$emit('agree', begin_date)">
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment';
export default {
  props: {
    dialog: Boolean,
    vehicleRequestId: Number,
  },
  data: () => ({
    begin_date: null,
  }),
  methods: {
    dateNow() {
      const begin = new Date();
      begin.setHours(begin.getHours());
      return moment(begin).toISOString(true);
    },
  },
};
</script>
<style scoped>
.secondary-color {
  background-color: var(--secondary-color) !important;
}
</style>
